export default __webpack_public_path__ + "static/Barn-1-e91eeec6431d34639357e5e47f00197c.png";